/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestLoginRequest
 */
export interface RequestLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestLoginRequest
     */
    mail?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestLoginRequest
     */
    password?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestLoginRequest
     */
    tenantId?: number;
}

/**
 * Check if a given object implements the RequestLoginRequest interface.
 */
export function instanceOfRequestLoginRequest(value: object): value is RequestLoginRequest {
    return true;
}

export function RequestLoginRequestFromJSON(json: any): RequestLoginRequest {
    return RequestLoginRequestFromJSONTyped(json, false);
}

export function RequestLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mail': json['mail'] == null ? undefined : json['mail'],
        'password': json['password'] == null ? undefined : json['password'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
    };
}

export function RequestLoginRequestToJSON(json: any): RequestLoginRequest {
    return RequestLoginRequestToJSONTyped(json, false);
}

export function RequestLoginRequestToJSONTyped(value?: RequestLoginRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mail': value['mail'],
        'password': value['password'],
        'tenant_id': value['tenantId'],
    };
}

